
import $ from 'jquery';

import BasePropertyView from 'BasePropertyView.js'
import { pickerCfg } from 'pickerCfg.js';
import contentTemplate from 'properties/style/text-color.ejs';
import themeService     from 'ThemeService.js';
import util from 'util/Util.js';

class StyleTextColorView extends BasePropertyView {

    initialize(opts) {
        super.initialize(opts);

        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'change #styleColorTextPicker' : 'updateColorAttributes',
            'change #styleColorText' : 'updateColorAttributesWithValidation', 
            'keydown #styleColorText': 'keyAction'
        };

        return this;
    }

    render() {
        super.render();
        let props = this.resolveThemeColors(this.model, ['styleColorText']);
        this.$el.html(this.template(props));

        //.$('input[type=color]', this.$el).spectrum(pickerCfg);

        this.delegateEvents();
        return this;
    }

    keyAction(ev) {
        var code = ev.keyCode || ev.which;
        if (code === 13) { 
            ev.preventDefault(); 
        }
    }

}

export default StyleTextColorView;
